import { createReducer, on } from '@ngrx/store';
import { loadCountries, loadCountriesSuccess, loadCountriesFailure } from './list.actions';

export interface ListState {
  countries: {
    list: any[];
    profileLists: any[];
    loading: boolean;
    success?: boolean;
    error: any;
  };
}

export const initialState: ListState = {
  countries: {
    list: [],
    profileLists: [],
    loading: false,
    error: null
  }
};

export const listReducer = createReducer(
  initialState,
  on(loadCountries, (state) => {
    // console.log('loadCountries action triggered', state);
    return {
      ...state,
      countries: { ...state.countries, loading: true, error: null }
    };
  }),
  on(loadCountriesSuccess, (state, { countries }) => {
    // console.log('loadCountriesSuccess action triggered', countries);
    return {
      ...state,
      countries: { ...state.countries, countries: countries, loading: false, success: true, error: null }
    };
  }),
  on(loadCountriesFailure, (state, { error }) => {
    // console.error('loadCountriesFailure action triggered', error);
    return {
      ...state,
      countries: { ...state.countries, error: error, loading: false }
    };
  })
);
